'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Button } from 'src/components/ui/primitives';
import styles from './top-navigation.module.css';

export function TopNavigation({ data }) {
  const pathname = usePathname().replace(/\/$/, '');
  return (
    <nav className={styles.nav} aria-label="Main navigation">
      {data
        .flatMap((section) => section.items)
        .map((item) => {
          const active =
            pathname === item.path ||
            (item.path !== '/dashboard' && pathname.startsWith(`${item.path}/`));
          return (
            <Button key={item.id || item.path} variant="ghost" asChild>
              <Link
                href={item.path}
                className={`${styles.item} ${active ? styles.active : ''}`}
                aria-current={active ? 'page' : undefined}
              >
                {item.icon}
                <span>{item.title}</span>
              </Link>
            </Button>
          );
        })}
    </nav>
  );
}
